import { trace } from 'owa-trace';
import { lazyCopyFluidComponent } from 'owa-fluid-integrations';
import { formatDate, now } from 'owa-datetime';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { CalendarEvent } from 'owa-calendar-types';

export const removeDownlevelLink = (eventBody: string) => {
    const downlevelLinkRegex = '<div id="?(?:x_)*FluidCollaborativeSpace"?[\\w\\W]+?</div>';
    const downlevelLink = eventBody.match(downlevelLinkRegex);
    if (downlevelLink?.length > 0) {
        eventBody = eventBody.replace(downlevelLink[0], '');
    }
    return eventBody;
};

const parseCollabSpace = (collabSpace: string | null) => {
    if (collabSpace) {
        try {
            const parsedCollabSpace = JSON.parse(collabSpace);
            return parsedCollabSpace;
        } catch (e) {
            trace.warn('Unable to parse collab space extended property: ' + collabSpace);
        }
    }
    return null;
};

async function createCollabSpaceCopy(shareLink: string, subject: string) {
    const formattedDate = formatDate(now(), 'MMddyyyy-HHmmss');
    const performanceDatapoint = new PerformanceDatapoint('FTDFCollabSpaceCopy');
    const newShareLink = await lazyCopyFluidComponent.importAndExecute(
        shareLink,
        `${subject} ${formattedDate}.note`
    );

    if (newShareLink?.length > 0) {
        performanceDatapoint.end();
    } else {
        performanceDatapoint.endWithError(
            DatapointStatus.RequestNotComplete,
            new Error('Copy fluid component request failed')
        );
    }

    return newShareLink;
}

export async function copyCollabSpaceIfPresent(event: CalendarEvent) {
    const parsedCollabSpace = parseCollabSpace(event.CollabSpace);
    event.CollabSpace = null;
    if (parsedCollabSpace?.metadata?.state === 'Enabled') {
        event.Body.Value = removeDownlevelLink(event.Body.Value);
        const newShareLink = await createCollabSpaceCopy(parsedCollabSpace.location, event.Subject);
        if (newShareLink) {
            parsedCollabSpace.location = newShareLink;
            event.CollabSpace = JSON.stringify(parsedCollabSpace);
        }
    }
}
